import { Box, Button } from "@mui/material";
import React from "react";
import * as XLSX from "xlsx";
import { Dialog } from "../Dialogs/Dialog";
import { IFileExtension, convertBase64ToBlob } from "./helpers";
import "./RenderHtmlFromBase64.css";
import { Download } from "@mui/icons-material";
import { useFileDownloader } from "../../hooks/useFileDownloader";
import { PreviewCSVFile } from "../Preview/PreviewCSVFile";
import { config } from "../../config";

export interface IViewImageDialog {
  open: boolean;
  file: string;
  fileType: IFileExtension;
  onClose: () => void;
  orgImageUrl?: string;
  onOpenInNewTab?: () => void;
}
export const ViewImageDialog: React.FC<IViewImageDialog> = (props) => {
  const { open, file, fileType, onClose, orgImageUrl, onOpenInNewTab } = props;

  const { downloadFile } = useFileDownloader();

  const handleNewTabClick = () => {
    const url = `${config.assets.docPreviewUrl}${config.assets.s3BaseUrl}/${file}`;
    window.open(url, "_blank");
  };

  const handlePreviewTxtInNewTab = () => {
    const text = atob(file.split(",")[1]);
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    window.open(url, "_blank");
  };

  return (
    <Dialog
      size={"xl"}
      open={open}
      title={""}
      rightHeading={
        <Box>
          {fileType === "EXCEL" && (
            <Button
              variant="outlined"
              size="small"
              sx={{ color: "#fff", borderColor: "#fff" }}
              onClick={handleNewTabClick}
            >
              Open in New Tab
            </Button>
          )}

          {fileType === "PDF" && (
            <Button
              variant="outlined"
              size="small"
              sx={{ color: "#fff", borderColor: "#fff" }}
              onClick={onOpenInNewTab}
            >
              Open in New Tab
            </Button>
          )}

          {fileType === "TXT" && (
            <Button
              variant="outlined"
              size="small"
              sx={{ color: "#fff", borderColor: "#fff" }}
              onClick={handlePreviewTxtInNewTab}
            >
              Open in New Tab
            </Button>
          )}

          <Button
            variant="outlined"
            size="small"
            sx={{ color: "#fff" }}
            onClick={() => downloadFile(orgImageUrl)}
          >
            <Download fontSize="small" />
          </Button>
        </Box>
      }
      onClose={onClose}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      // width="100%"
      >
        {fileType === "IMAGE" ? (
          <img alt="preview" src={file} style={{ maxHeight: "80vh" }} />
        ) : fileType === "PDF" ? (
          <iframe
            title="pdf-file-view"
            src={file}
            style={{ width: "100%", height: "auto", minHeight: "90vh" }}
          />
        ) : fileType === "TXT" ? (
          <Box
            sx={{
              width: "100%",
              maxHeight: "80vh",
              overflow: "auto",
              background: "#111",
              color: "#fff",
              p: 2,
              borderRadius: 1,
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
            }}
          >
            {atob(file.split(",")[1])}
          </Box>
        ) : fileType === "EXCEL" ? (
          <iframe
            title="excel-file-view"
            src={`${config.assets.docPreviewUrl}${config.assets.s3BaseUrl}/${file}`}
            style={{ width: "100%", height: "auto", minHeight: "90vh" }}
          />
        ) : fileType === "CSV" ? (
          <PreviewCSVFile filePath={file} />
        ) : (
          <></>
        )}
      </Box>
    </Dialog>
  );
};

export const RenderHtmlFromBase64: React.FC<{ base64File: string }> = ({
  base64File,
}) => {
  const [__html, setHTML] = React.useState("");
  React.useEffect(() => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      const bstr = evt?.target?.result as ArrayBuffer;
      const workbook = XLSX.read(bstr, { type: "binary" });
      const worksheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheet_name];
      const data = XLSX.utils.sheet_to_html(worksheet);
      setHTML(data);
    };
    reader.readAsArrayBuffer(convertBase64ToBlob(base64File));
  }, []);
  return <div id="table_sheet" dangerouslySetInnerHTML={{ __html }} />;
};

export const RenderExcelFile: React.FC<{ fileUrl: string }> = ({ fileUrl }) => {
  return (
    <iframe
      src={fileUrl}
      style={{ width: "100%", height: "auto", minHeight: "90vh" }}
    />
  );
};
